/**
 * 插件注册模块
 * 负责注册所有 Vue 插件和中间件
 */

import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { Lazyload } from 'vant'
import router from '@/router'
import i18n from '@/locales'
import IMConnectionRouter from '@/plugins/IMConnectionRouter'
import IMMessageRouter from '@/plugins/IMMessageRouter'
import { getStorageKey } from '@/utils'
import { isDebugMode } from '@/utils'

/**
 * 配置并注册所有插件到 Vue 应用实例
 * @param {App} app - Vue 应用实例
 */
export function setupPlugins(app) {
  // 1. 配置 Pinia Store
  const pinia = createPinia()
  pinia.use(createPersistedState({
    key: id => getStorageKey(`${id}`),
    debug: isDebugMode,
  }))

  // 2. 注册插件
  app.use(Lazyload)
  app.use(pinia)
  app.use(router)
  app.use(i18n)
  app.use(IMConnectionRouter) // IM 连接状态路由插件
  app.use(IMMessageRouter) // IM 消息路由插件
}
